import React, { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip as MuiTooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const TablaLogistica = () => {
  const [openInfo, setOpenInfo] = useState(false);

  const data2022 = [
    ['Servicios logísticos', '8%', '19%', '50%', '8%', '22%', '50%', '10%', '24%', '50%'],
    ['Automotriz', '1%', '7%', '13%', '1%', '10%', '20%', '4%', '11%', '20%'],
    ['Manufactura', '2%', '4%', '8%', '5%', '6%', '6%', '3%', '9%', '13%'],
    ['Alimentos', '1%', '5%', '15%', '1%', '6%', '18%', '1%', '9%', '25%'],
    ['Construcción', '1%', '5%', '10%', '1%', '6%', '10%', '3%', '7%', '13%'],
    ['Sector salud/Farmacéuticas', '1%', '4%', '9%', '1%', '5%', '11%', '2%', '8%', '18%'],
    ['Retail', '1%', '3%', '8%', '1%', '4%', '12%', '3%', '6%', '15%'],
  ];

  const data2023 = [
    ['Servicios logísticos', '3%', '13%', '25%', '5%', '15%', '34%', '2%', '17%', '41%'],
    ['Automotriz', '2%', '2%', '2%', '2%', '14%', '35%', '15%', '15%', '15%'],
    ['Manufactura', '2%', '3%', '9%', '3%', '4%', '5%', '4%', '5%', '6%'],
    ['Alimentos', '1%', '9%', '23%', '1%', '15%', '60%', '2%', '13%', '45%'],
    ['Construcción', '5%', '11%', '17%', '2%', '11%', '20%', '7%', '11%', '14%'],
    ['Sector salud/Farmacéuticas', '8%', '8%', '8%', '3%', '3%', '3%', '12%', '12%', '12%'],
    ['Retail', '1%', '4%', '25%', '2%', '15%', '85%', '1%', '11%', '79%'],
  ];

  const columnas = ['Mín.', 'Prom.', 'Máx.', 'Mín.', 'Prom.', 'Máx.', 'Mín.', 'Prom.', 'Máx.'];

  const infoContent = {
    analisis: `El costo logístico total como proporción de las ventas en dos periodos consecutivos, desglosado en transporte, distribución y total de servir por industria. En 2023 se observan cambios importantes en la estructura de costos logísticos, con industrias como Retail, Alimentos y Servicios logísticoss registrando mayores variabilidades en los máximos reportado`,
    formula: `Promedio de los costos`,
    descripcion: `Los datos evidencian que el costo logístico total sigue siendo un reto relevante para muchas industrias, especialmente en aquellas con mayores exigencias de cobertura y servicio al cliente. Las diferencias por sector reflejan la diversidad de estrategias logísticas y su impacto financiero, reforzando la necesidad de monitorear estos indicadores para mejorar eficiencia y competitividad.`,
  };

  return (
    <Box mt={4}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la tabla">
          <IconButton onClick={() => setOpenInfo(true)} size="small">
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>

      <Typography variant="h6" align="center" gutterBottom>
        Costo Logístico como % de las Ventas Totales (2022)
      </Typography>
      <Tabla datos={data2022} columnas={columnas} año="2022" />

      <Typography variant="h6" align="center" gutterBottom sx={{ mt: 4 }}>
        Costo Logístico como % de las Ventas Totales (2023)
      </Typography>
      <Tabla datos={data2023} columnas={columnas} año="2023" />

      <Dialog open={openInfo} onClose={() => setOpenInfo(false)}>
        <DialogTitle>Información de las Tablas</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" gutterBottom><strong>Análisis:</strong></Typography>
          <Typography paragraph>{infoContent.analisis}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Fórmula:</strong></Typography>
          <Typography paragraph>{infoContent.formula}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Descripción:</strong></Typography>
          <Typography paragraph>{infoContent.descripcion}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenInfo(false)} color="primary">Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const Tabla = ({ datos, columnas, año }) => (
  <Box sx={{ overflowX: 'auto', mb: 4 }}>
    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <thead>
        <tr>
          <th rowSpan="2" style={{ ...thStyle, backgroundColor: '#e6efdb' }}>Industria</th>
          <th colSpan="3" style={{ ...thStyle, backgroundColor: '#e6efdb' }}>Costo de transporte</th>
          <th colSpan="3" style={{ ...thStyle, backgroundColor: '#e6efdb' }}>Costo de distribución</th>
          <th colSpan="3" style={{ ...thStyle, backgroundColor: '#e6efdb' }}>Costo logístico total</th>
        </tr>
        <tr>
          {columnas.map((label, i) => (
            <th key={i} style={{ ...thStyle, backgroundColor: '#e6efdb' }}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {datos.map((fila, idx) => (
          <tr key={idx}>
            {fila.map((valor, i) => {
              // Índices 2, 5, 8 = columnas "Promedio"
              const isPromedio = [2, 5, 8].includes(i);
              const bgColor = isPromedio
                ? año === '2022'
                  ? '#cce5ff' // verde claro
                  : '#fbe4d5' // naranja claro
                : 'transparent';
              return (
                <td key={i} style={{ ...tdStyle, backgroundColor: bgColor }}>{valor}</td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  </Box>
);

const thStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  textAlign: 'center',
  fontWeight: 'bold',
};

const tdStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  textAlign: 'center',
};

export default TablaLogistica;
